import { formatPrice } from "@/lib";

// "AIR France/Flying Blue" is listed by its program, "Flying Blue".
export function programDisplayName(name: string) {
  return name.split("/").pop()?.trim() || name;
}

export function money(price: number) {
  return formatPrice({ price, fractionDigits: 2 });
}
